<template>
    <div class="plan">
      <div :class="{'show': popupActionShow}" class="overlay" @click.self="resetPopupData()">
        <div class="popup">
        <span v-if="!isUpdate" class="title">{{ $t('marketing.plan.title') }}</span>
        <span v-else class="title">{{ $t('general.edit', { name: actionDetailData.complete_name }) }}</span>
        <div class="config">
          <v-container>
            <v-select
              v-if="!isUpdate"
              :items="strategies"
              item-text="complete_name"
              item-value="id"
              v-model="strategy_id"
              :label="$t('general.strategy')"
              class="strategy"
            ></v-select>

            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="start_date"
              persistent
              lazy
              full-width
              width="290px"
              class="date"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="start_date"
                  :label="$t('general.start_date')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="start_date" :min="(this.selectedYear+'-01-01')"
              :max="(this.selectedYear+'-12-31')" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false">{{ $t('general.cancel') }}</v-btn>
                <v-btn flat color="primary" @click="dateSelect(start_date, 'start_date')">{{ $t('general.accept') }}</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="dialog2"
              v-model="modal2"
              :return-value.sync="end_date"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="end_date"
                  :label="$t('time.end_date')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  id="end_date"
                ></v-text-field>
              </template>
              <v-date-picker v-model="end_date" :min="(this.selectedYear+'-01-01')"
              :max="(this.selectedYear+'-12-31')" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false">{{ $t('general.cancel') }}</v-btn>
                <v-btn flat color="primary" @click="dateSelect(end_date, 'end_date')">{{ $t('general.accept') }}</v-btn>
              </v-date-picker>
            </v-dialog>

          </v-container>
          <div v-if="!isUpdate" class="save" @click="checkAction()">{{ $t('marketing.plan.add') }}</div>
          <div v-else class="save" @click="updateAction()">{{ $t('marketing.plan.edit') }}</div>
        </div>
        </div>
      </div>


      <div id="content">
        <div class="watermark">{{selectedLocation.site}}</div>
        <div class="row">
          <div class="month">{{ $t('months.january') }}</div>
          <div class="month">{{ $t('months.february') }}</div>
          <div class="month">{{ $t('months.march') }}</div>
          <div class="month">{{ $t('months.april') }}</div>
          <div class="month">{{ $t('months.may') }}</div>
          <div class="month">{{ $t('months.june') }}</div>
          <div class="month">{{ $t('months.july') }}</div>
          <div class="month">{{ $t('months.august') }}</div>
          <div class="month">{{ $t('months.september') }}</div>
          <div class="month">{{ $t('months.october') }}</div>
          <div class="month">{{ $t('months.november') }}</div>
          <div class="month">{{ $t('months.december') }}</div>
        </div>
        <!--<div class="row">
          <div class="national">NACIONAL</div>
        </div>-->
        <!-- <div class="row">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in national" class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div> -->
        <div class="row">
          <div v-if="obj1 == undefined" class="objective">{{ $t('marketing.plan.priority.1') }}</div>
          <div v-else class="objective">{{obj1}}</div>
        </div>
        <div class="row" data-type="1">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in actions" v-if="action.row == 1" class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div>
        <div class="row" data-type="2">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in actions" v-if="action.row == 2" class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div>
         <div class="row">
          <div v-if="obj2 == undefined" class="objective">{{ $t('marketing.plan.priority.2') }}</div>
          <div v-else class="objective">{{obj2}}</div>
        </div>
        <div class="row" data-type="3">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in actions" v-if="action.row == 3" class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div>
        <div class="row"  data-type="4">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in actions" v-if="action.row == 4" class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div>
         <div class="row">
          <div v-if="obj3 == undefined" class="objective">{{ $t('marketing.plan.priority.3') }}</div>
          <div v-else class="objective">{{obj3}}</div>
        </div>
        <div class="row"  data-type="5">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in actions" v-if="action.row == 5 " class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div>
        <div class="row"  data-type="6">
          <div class="four" v-for="index in 12" :key="index"></div>
          <div v-for="action in actions" v-if="action.row == 6" class="event" @click="actionDetail( action )" :style="{left: (action.start_week * 100 / 365) + '%', width: (action.duration * 100/52) + '%'  }">{{action.name}}</div>
        </div>
      </div>

      <div :class="{'show': popupActionDetailShow}" class="overlay" @click.self="resetPopupData()">
        <div class="popup detail" v-if="actionDetailData!=undefined">
          <div class="row">
            <div class="title">{{actionDetailData['complete_name']}}</div>
          </div>

          <!-- <div class="row">
            <div class="name">Tipo:</div>
            <div v-if="actionDetailData['type']==1">Acción Nacional</div>
            <div v-else-if="actionDetailData['type']==2">Acción Local</div>
          </div> -->

          <div class="row">
            <div class="name">{{ $t('general.start_date') }}:</div>
            <div>{{actionDetailData['startHuman']}}</div>
          </div>

          <div class="row">
            <div class="name">{{ $t('time.end_date') }}:</div>
            <div>{{actionDetailData['endHuman']}}</div>
          </div>

          <div class="buttons">
            <div class="button" @click="popupActionDetailShow = false">{{ $t('general.close') }} <v-icon>close</v-icon></div>
            <div v-if="actionDetailData['type']==2" class="button" @click="updatePopup(actionDetailData['id'])">{{ $t('general.edit') }} <v-icon>edit</v-icon></div>
            <div v-if="actionDetailData['type']==2" class="button" @click="deleteAction(actionDetailData['id'])">Eliminar <v-icon>delete</v-icon></div>
          </div>

        </div>
      </div>  
      
      <div class="actions">
        <div class="action list">
          <div class="header">
            {{ $t('marketing.plan.defined', { year: selectedYear }) }}
          </div>
         <!--  <div class="type">
            <div class="subheader">Nacional</div>
            <div class="row" v-for="item in national" @click="actionDetail( item )" style="cursor: pointer;" v-if="item.type == 1">
              <span class="name">{{item.complete_name}}</span>
              <span class="date">{{item.end}}</span>
              <span class="date">-</span>
              <span class="date">{{item.start}}</span>
            </div>
          </div> -->
          <div class="type">
            <div class="subheader">{{ $t('marketing.plan.local') }}</div>
            <div class="row" v-for="item in actions" @click="actionDetail( item )" style="cursor: pointer;" v-if="item.type == 2">
              <span class="name">{{item.complete_name}}</span>
              <span class="date">{{item.endHuman}}</span>
              <span class="date">-</span>
              <span class="date">{{item.startHuman}}</span>
            </div>
          </div>
        </div>
        <div class="create no-print" @click="popupActionShow = true">
          <span class="action">{{ $t('marketing.plan.create') }}</span>
          <v-icon class="add">add</v-icon>
        </div>
      </div>

    </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: {plan: Array},
  data () {
    return {
      popupActionShow: false,
      popupActionDetailShow: false,
      isUpdate: false,

      actionDetailData: undefined,

      strategyOptions: [],

      actions: [],

      modal: "",
      modal2: "",

      obj1: undefined,
      obj2: undefined,
      obj3: undefined,

      strategy_id: "",
      action_id: "",
      start_date: "",
      end_date: "",

    }
  },
  computed: {
    selectedLocation (){
      return this.restaurant = this.$store.getters['locations/getSelectedLocation'];
    },

    selectedYear(){
      return this.$parent.selectedYear;
    },

    // national() {
    //   var actions = this.$store.getters['locations/getNationalActions'];

    //   for(var idx in actions) {
    //     var action = actions[idx];
    //     var weeks = (moment(action.end).diff(moment(action.start), 'days') / 7);
    //     var start_week = moment(action.start).dayOfYear();
    //     action.duration = weeks;
    //     action.start_week = start_week;
    //     action.type = 1;
    //     action.startHuman = moment(action.start).format("DD/MM/YYYY");
    //     action.endHuman = moment(action.end).format("DD/MM/YYYY");
    //     action.complete_name = action.name;
    //   }

    //   return actions;
    // },

    strategies() {
      var result = [];
      if (this.plan[0] != undefined) {
        var objectiveName = "";
        var objectiveIndex = 0;
        for ( var index in this.plan ) {
          var item = this.plan[index];

          for ( var subindex in item.strategies ) {
            result.push({name: item.strategies[subindex].name, id: item.strategies[subindex].id, complete_name: item.name + "  →  " + (item.strategies[subindex].name ? item.strategies[subindex].name : item.strategies[subindex].strategy_name) });
          }
        }
      }
      return this.strategyOptions = result;
    },

    actionsParsed() {
      if (this.plan[0] != undefined) {
        for ( var index in this.plan ) {
          var item = this.plan[index];

          // This loads the name of the objectives and var objX is used to check if objective is set
          if (this.plan[index]!=undefined) {
            this["obj"+item.status] = item.name;
          }

          for ( var subindex in item.actions ) {
            var action = item.actions[subindex];
            item.actions[subindex].row = parseInt(item.strategies[action.strategy_id].status);
            var weeks = ((moment(item.actions[subindex].end).diff(moment(item.actions[subindex].start), 'days') / 7));
            var start_week = moment(item.actions[subindex].start).dayOfYear();
            item.actions[subindex].duration = weeks;
            item.actions[subindex].start_week = start_week;
            item.actions[subindex].startHuman = moment(action.start).format("DD/MM/YYYY");
            item.actions[subindex].endHuman = moment(action.end).format("DD/MM/YYYY");
            item.actions[subindex].complete_name = item.name + "  →  " + action.name;     
            this.actions.push(item.actions[subindex]);
          }
        }
      }
      else {
        this.obj1= undefined;
        this.obj2= undefined;
        this.obj3= undefined;
      }
    },

    // strategiesParsed () {
    //   if (this.strategies[0].strategies!=undefined){
    //     return JSON.parse(this.strategies[0].strategies);
    //   }
    // },

  },
  methods: {
    checkAction() {
      var self = this;

      //Checks that the data is filled is correct
      if (this.strategy_id == "") {
        this.$popup.alert(i18n.t('marketing.plan.popup.empty_strategy'));
        return;
      }

      if (this.end_date == "" || this.start_date == "") {
        this.$popup.alert(i18n.t('marketing.plan.popup.empty_date'));
        return;
      }

      if (moment(this.end_date).isBefore(this.start_date)) {
        this.$popup.alert(i18n.t('marketing.plan.popup.end_date'));
        return;
      }

      if (moment(this.end_date).isAfter(moment(this.selectedYear+'-01-01').endOf('year'))) {
        this.$popup.alert(i18n.t('marketing.plan.popup.year_date'));
        return;
      }

      if (moment(this.start_date).isBefore(moment(this.selectedYear+'-01-01').startOf('year'))) {
        this.$popup.alert(i18n.t('marketing.plan.popup.year_date'));
        return;
      }

      //Search if action exists and that there is no actions in this period
      // var search = this.actions.filter(function(item) { return item.strategy_id == self.strategy_id});

      // if ( search.length > 0 ) {
      //   for ( var index in search ) {
      //     var item = this.actions[index];
      //     if ( !(moment(this.end_date).isSameOrBefore(item.start) || moment(this.start_date).isSameOrAfter(item.end)) ) {
      //       var self = this;
      //       this.$popup.confirm( 
      //         "Accion solapada", 
      //         "Se ha detectado que ya hay definida esta acción en estas fechas. ¿Quieres continuar?", 
      //         "Crear", 
      //         "Cancelar",
      //         function(){
      //            self.save();
      //         }
      //       );
      //       break;
      //     }
      //     this.save();
      //   }
      // }
      // else {
        this.save();
      // }

    },

    save() {
      this.$overlay.loading();
      var aData= {};
      aData.Data = JSON.stringify({
        name: this.name,
        strategy_id: this.strategy_id,
        start_date: this.start_date,
        end_date: this.end_date,
        type: 2,
        status: 1,
      });
      aData.restaurant_id = this.$store.getters['locations/getSelectedLocation'].id;
      aData.year = this.selectedYear;
      var self = this;
      this.$store.dispatch( 'locations/addAction', aData ).then(function(){
        self.resetPopupData();
        self.$store.dispatch('locations/loadMarketing', {restaurant_id: self.$store.getters['locations/getSelectedLocation'].id, year: self.selectedYear} ).then(function(){
          self.$overlay.hide();
        })
      });
    },

    dateSelect( date, mode) {
      switch (mode) {
        case 'start_date':
          this.$refs.dialog.save(date);
          // let clickEvent = new Event('click');
          // document.getElementById('end_date').dispatchEvent(clickEvent)
          break;
        case 'end_date':
          this.$refs.dialog2.save(date)
          break;
      }
    },

    actionDetail ( action ) {
      this.actionDetailData = action;
      this.popupActionDetailShow = true;
    },

    deleteAction (id) {
      var self = this;
      this.$overlay.loading();
      this.$store.dispatch('locations/deleteAction', id ).then(function(){
        self.$store.dispatch('locations/loadMarketing', {restaurant_id: self.$store.getters['locations/getSelectedLocation'].id, year: self.selectedYear} ).then(function(){
            self.$overlay.hide();
        });
        self.popupActionDetailShow = false;
      });
    },

    updatePopup (id) {
      this.isUpdate = true;
      this.action_id = id;
      this.start_date = this.actionDetailData.start;
      this.end_date = this.actionDetailData.end;
      this.popupActionShow = true;
      this.popupActionDetailShow = false;
    },

    updateAction(id) {
      var self = this;
      this.$overlay.loading();
      var aData= {};
      aData.Data = JSON.stringify({
        action_id: this.action_id,
        start_date: this.start_date,
        end_date: this.end_date,
      });
      this.$store.dispatch( 'locations/updateAction', aData ).then(function(){
        self.resetPopupData();
        self.$store.dispatch('locations/loadMarketing', {restaurant_id: self.$store.getters['locations/getSelectedLocation'].id, year: self.selectedYear} ).then(function(){
          self.$overlay.hide();
        })
      });
    },

    resetPopupData() {
      this.isUpdate = false;
      this.popupActionShow = false;
      this.popupActionDetailShow = false;
      this.strategy_id = "";
      this.action_id = "";
      this.start_date = "";
      this.end_date = "";
    }
  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
      this.$store.dispatch('locations/loadCompetence', this.$store.getters['locations/getSelectedLocation'].id );
     },

     plan () {
      this.actions = [];
      // this.national;
      this.actionsParsed;
      this.strategies;
      this.objectivesName;
    },

  },
  created() {
    this.$store.dispatch('locations/loadCompetence', this.$store.getters['locations/getSelectedLocation'].id );
    this.actionsParsed;
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

/* LISTADO DE ACCIONES */
  .actions {
    margin: 30px 0px;
    overflow: auto;

    .list {
      width: 70%;
      float: left;
      text-align: left;
      background-color: #eee;
      padding : 20px;
      margin-right: 5%;
      border-radius: 5px;

      .header {
        text-indent: 5px;
        font-size: 20px;
        text-align: center;
        border-bottom: 2px solid #cacaca;
        font-weight: bold; 
      }

      .subheader {
        text-align: center;
        font-size: 18px;
        text-transform: uppercase;
        margin-top: 10px;
      }

      .row {
        display: inline-block;
        width: 100%;
        background-color: white;
        padding: 10px 20px;
        border-radius: 5px;
        margin-top: 10px;
        font-size: 16px;

        .name {
          font-size: 18px;
        }

        .date {
          color: #888;
          float: right;
          width: fit-content;
          margin-right: 10px;
        }
      }
    }


  /* CREAR ACCION */
    .create {
      width: 25%;
      float: right;
      text-align: center;
      background-color: #eee;
      cursor: pointer;
      border: 1px solid #aaa;
      padding: 20px;
      border-radius: 5px;
      overflow: auto;

      .action{
        font-size: 18px;
        display: inline-block;
      }

      .add {
        display: block;
        font-size: 50px;
        color: #4ca54c;
      }

      &:hover {
        color: white;
        transition: 0.3s;
        background-color: #4ca54c;

        .add {
          color: white;
        }
      }
    }
  }
  


/* GRAFICO */
  #content {
    background-color: var(--main_color);
    position: relative;
    font-size: 14px;
    width: 100%;
    margin: 20px auto;
    border-radius: 2px;
    overflow: hidden;
    height: auto;
    border: 1px solid #cacaca;
    border-bottom: none;


    .watermark{
      position: absolute;
      width: 100%;
      top: 110px;
      color: rgba(0,0,0,0.07);
      font-size: 300px;
      line-height: 0.6;
      text-align: center;
      z-index: 2;
      cursor: default;
      pointer-events: none;
      user-select: none;
    }

    /*.national {
      background-color: #f2b3b3;
      height: 120px;
      text-align: center;
      line-height: 5;
      font-size: 20px;
    }*/

    .row {
      display: block;
      text-align: left;
      border: 1px;
      position: relative;
      overflow: hidden;

      .objective {
        background-color: #eee;
        text-align: center;
        padding: 5px;
        font-size: 15px;

        &:first-child {
          /*border-top: 50px solid #f9f9f9;*/
        }
      }

      .event {
        width: 150px;
        position: absolute;
        z-index: 1;
        top: 5px;
        left: 0;
        height: 30px;
        background: red;
        border: 0px solid black;
        padding: 0px 5px;
        font-size: 13px;
        line-height: 30px;
        color: #fff;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
      }

      &[data-type="1"] {
        .event {
          background-color: #8bc34a;
        }
      }
      &[data-type="2"] {
        .event {
          background-color: #8bc34a;
        }
      }
      &[data-type="3"] {
        .event {
          background-color: #673ab7;
        }
      }
      &[data-type="4"] {
        .event {
          background-color: #673ab7;
        }
      }
      &[data-type="5"] {
        .event {
          background-color: #00bcd4;
        }
      }
      &[data-type="6"] {
        .event {
          background-color: #00bcd4;
        }
      }

      .month {
        text-align: center;
        display: inline-block;
        width: calc(100%/12);
        white-space: nowrap;
        font-size: 14px;
        color: #fff;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 5px;
      }

      .four {
        background-color: white;
        width: calc(100%/12);
        height: 40px;
        display: inline-block;
        border: 1px solid #ddd;
        z-index: 1;
        float: left;
        font-size: 20px;
        text-align: center;
        line-height: 1.8;
        position: relative;

        &:nth-child(4n) {
          //border-right: 2px solid var(--secondary_color);
        }

        &:last-child {
          border-right: none;
        }

        &.selected {
          background-color: orange;
          border: 1px solid rgba(0,0,0,0.2);
        }
      }
    }
  }

/* POPUP */
.overlay {
    display: none;
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    transition: opacity 500ms;
    visibility: hidden;
    opacity: 0;

    &.show {
      display: unset;
      visibility: visible;
      opacity: 1;
    }

    .popup {
      visibility: visible;
      position: fixed;
      background-color: white;
      top: calc(50% - 250px);
      width: 85%;
      left: 50%;
      margin-left: -42.5%;
      height: fit-content;
      padding: 20px 10px;
      border-radius: 5px;

      &.detail {
        font-size: 17px;

        .row {
          display: block;
          margin: 10px 0px;

          div {
            display: inline;
          }

          .name {
            display: inline-block;
            font-weight: bold;
            margin-right: 10px;
            text-align: left;
          }
        }

        .buttons {
          display: block;
          margin-top: 40px;

          .button {
            display: inline;
            margin: 50px;
            cursor: pointer;
          }
        }     
      }

      .title {
        margin: 20px auto;
      }
  
      .save {
        border-radius: 10px;
        background-color: #ddd;
        padding: 10px 20px;
        width: fit-content;
        margin: 10px auto;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;

      &:hover {
          background-color: var(--main_color);
        }
      }
    }
  }

</style>
